export default __webpack_public_path__ + "static/media/pose.897ce577.png";